import { CommonModule, DecimalPipe, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import locale from '@angular/common/locales/es-CO';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppInterceptorService } from '@core/interceptors/app-interceptor.service';
import { AppMockInterceptorService } from '@core/interceptors/app-mock-interceptor.service';
import { AppInitializer } from '@core/services/app-initializer.service';

import { appEffects, appReducers } from '@app/domain/store/index';
import { environment } from '@environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxMaskModule } from 'ngx-mask';
import { AppTransactionInterceptor } from './core/interceptors/app-transaction.interceptor';
import { MOLayoutModule } from './presentation/mo-layout/mo-layout.module';
import { PowerpayCurrencyPipe } from './presentation/mo-layout/pipes/powerpay-currency.pipe';

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HammerModule,
    AppRoutingModule,
    MOLayoutModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatDialogModule,
    MatSnackBarModule,
    NgxMaskModule.forRoot(),
    StoreModule.forRoot(appReducers),
    EffectsModule.forRoot(appEffects),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ],
  providers: [
    DecimalPipe,
    PowerpayCurrencyPipe,
    { provide: LOCALE_ID, useValue: 'es-CO' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppTransactionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppMockInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptorService,
      multi: true,
    },
    { provide: APP_INITIALIZER, useFactory: AppInitializer, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
registerLocaleData(locale, 'es-CO');
